export default __webpack_public_path__ + "static/media/debt-free-shop.8989c9e2.svg";